// extracted by mini-css-extract-plugin
export var formContainer = "_f4-0";
export var message = "_f4-1";